<template>
  <div>
    <v-data-table
      item-key="id"
      :headers="headers"
      :loading="loading"
      :items="CVs"
      :items-per-page="10"
      :footer-props="{'items-per-page-text': 'Số Hồ Sơ một trang'}"
      disable-sort
      :server-items-length="count"
      v-bind="this.$attrs"
      :options.sync="pagination"
    >
      <template v-slot:[`footer.page-text`]="items">
        Hồ sơ thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} Hồ sơ
      </template>
      <template v-slot:[`item.code`]="{item}">
        <v-btn
          class="document-btn text-none text-decoration-underline px-0"
          color="primary"
          @click="onDocumentClick(item.id)"
          plain
        >
          {{ item | getCode }}
        </v-btn>
      </template>
      <template v-slot:[`item.department`]="{item}">
        {{ item | getDepartment }}
      </template>
      <template v-slot:[`item.name`]="{item}">
        {{ item | getStudent }}
      </template>
      <template v-slot:[`item.parentPhone`]="{item}">
        {{ item | getUserPhone }}
      </template>
      <template v-slot:[`item.reserveRegisterState`]="{item}">
        <v-chip :color="item.reserveRegisterState === 'success' ? 'success' : 'warning'" small>
          {{ item.reserveRegisterState | getStatus }}
        </v-chip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {get} from 'lodash'
import moment from 'moment'
const baseHeaders = [
  {text: 'Mã hồ sơ', value: 'code'},
  {text: 'Cơ sở', value: 'department'},
  {text: 'Tên thí sinh', value: 'name'},
  {text: 'Điểm NN', value: 'ltvExamResult.examLanguage', align: 'center'},
  {text: 'Điểm TD', value: 'ltvExamResult.examMathMark', align: 'center'},
  {text: 'Tổng điểm', value: 'ltvExamResult.examTotal', align: 'center'},
  {text: 'SĐT tài khoản', value: 'parentPhone'},
  {text: 'Trạng thái', value: 'reserveRegisterState'},
]

export default {
  computed: {
    ...mapGetters('cv', ['CVs', 'count', 'filterParams']),
    ...mapGetters('auth', ['user', 'role']),
    headers() {
      return baseHeaders
    },
  },
  data: () => ({loading: false, pagination: {}}),
  watch: {
    pagination: {
      async handler(newOptions, oldOptions) {
        if (newOptions && oldOptions) {
          await this.refresh((newOptions.page - 1) * newOptions.itemsPerPage, newOptions.itemsPerPage)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions({fetchCVs: 'cv/fetchCVs', cancelRegisterG6ExamPrep: 'cv/cancelRegisterG6ExamPrep'}),
    getBaseQuery() {
      const query = {
        type: 'Khối 6',
        populates: 'parent',
        enrollmentFlag: 'reserve',
      }
      if (this.user.department === 'both') {
        if (!Object.keys(this.filterParams).includes('department_in'))
          query.department_in = ['Cơ sở A', 'Cơ sở 1', 'unset']
      } else query.department_in = [this.user.department, 'unset']
      if (!this.user.department || this.user.department !== 'both') query.status_ne = 'disabled'
      return query
    },
    async refresh(_start = 0, _limit = 10) {
      this.loading = true
      await this.fetchCVs({...this.getBaseQuery(), _start, _limit})
      this.loading = false
    },
    onDocumentClick(documentId) {
      this.$emit('onDocumentDetail', documentId)
    },
    onCancel(item) {
      this.$dialog.confirm({
        title: 'Xác nhận huỷ đăng ký lớp HDPPLB',
        okText: 'Xác nhận',
        topContent: '',
        midContent: `Thao tác này sẽ khiến hồ sơ ${item.code} trở thành không đăng ký. Nếu đã chắc chắn vui lòng bấm vào nút "Xác nhận" phía dưới để tiếp tục.`,
        botContent: '',
        cancelText: 'Kiểm tra lại',
        done: async () => {
          this.$loading.active = true
          try {
            await this.cancelRegisterG6ExamPrep(item.id)
            await this.refresh()
            this.$alert.success(`Huỷ đăng ký lớp HDPPLB cho hồ sơ ${item.code} thành công`)
          } catch (error) {
            this.$alert.error(error)
          } finally {
            this.$loading.active = false
          }
        },
      })
    },
  },
  filters: {
    getUserPhone: item => get(item, 'parentUsername', '---'),
    getStudent: item => get(item, 'name', '---'),
    getDepartment: item => {
      if (!item.department || item.department === 'unset') return '---'
      else return item.department
    },
    getCode: item => get(item, 'code', '---'),
    getTransactionTime: item =>
      moment(get(item, 'g6ExamPrepTransactions.0.transactionTime')).format('DD/MM/YYYY HH:mm'),
    getStatus: v => (v === 'success' ? 'Đã đăng ký' : 'Chưa đăng ký'),
  },
}
</script>
